module.exports = __webpack_public_path__ + "img/step4-c.a250e484.png";